import * as React from "react";
import LazyLoad from "react-lazyload";

export default class Media extends React.Component {
    // model props
    constructor(props) {
        super(props);

    }

    render() {
        const { model } = this.props;
        //console.debug("model.value", model);
        if (!model.value) return (null); // Early out..

        const url = model.value.image;
        //return (<div>RENDER:media</div>)
        return (<LazyLoad height={400} offset={100}>
            <img src={url} alt={model.value.caption} />
        </LazyLoad>);
    }
}